import {invokeApig} from "../../libs/awsLib";
import Paths from "../paths";
import {myID} from "../../libs/generateID";
import store from "../../store/store";
import {notify} from "reapop";
import i18next from "i18next";

/**
 * funkcja do tworzenia zasiedlen z widoku zarzadzania zasiedlen
 * @param PlcmntID {string} id komory
 * @param DtaEndTime {number|null} czas utc stopu zasiedlenia
 * @param DtaStartTime {number} czas startu zasiedlenia
 * @return {Promise<*|undefined>}
 */
export function createSettlement({PlcmntID, DtaEndTime, DtaStartTime, Age} = {}) {
    return invokeApig({
        ...Paths.createSettlement(),
        body: {PlcmntID, DtaStartTime, DtaEndTime, Age}
    })
}

export function createSettlementNotificationSuccess(response, {uniqueId = myID()} = {}) {
    store.dispatch(notify({
        id: uniqueId,
        title: i18next.t("apiNotifications.createSettlementTitle"),
        message: i18next.t("apiNotifications.createSettlementSuccess"),
        status: 'success',
        dismissible: true,
        dismissAfter: 5000
    }))
}

export function createSettlementNotificationFailure(response, {uniqueId = myID()} = {}) {
    console.log(response);
    store.dispatch(notify({
        id: uniqueId,
        title: i18next.t("apiNotifications.createSettlementTitle"),
        message: i18next.t("apiNotifications.createSettlementFailure"),
        status: 'error',
        dismissible: true,
        dismissAfter: 15000
    }))
}
